export const commonVariantToken = (FOUNDATIONS, VARIANT_TOKENS) => ({
    wrapper: {
        width: '100%',
        height: FOUNDATIONS.size_325,
        display: 'flex',
        align_items: 'center',
        justify_content: 'center',
        position: 'relative',
        ...VARIANT_TOKENS.wrapper,
    },
    bar: {
        border_radius: FOUNDATIONS.radius_100,
        height: FOUNDATIONS.size_50,
        width: FOUNDATIONS.size_550,
        background_color: FOUNDATIONS.color_comp_navigation_scrollcontroller_track_bg,
        position: 'relative',
        ...VARIANT_TOKENS.bar,
    },
    indicator: {
        border_radius: FOUNDATIONS.radius_100,
        background_color: FOUNDATIONS.color_comp_navigation_scrollcontroller_bar_bg,
        min_width: FOUNDATIONS.size_75,
        height: FOUNDATIONS.size_50,
        position: 'absolute',
        transition: 'left 0.2s ease-in-out', // fix this value
        ...VARIANT_TOKENS.indicator,
    },
    hideContainer: {
        width: '100%',
        position: 'absolute',
        display: 'flex',
        height: '100%',
        ...VARIANT_TOKENS.hideContainer,
    },
    hideButton: {
        position: 'relative',
        width: '50%',
        background_color: 'transparent',
        cursor: 'pointer',
        height: '100%',
        ...VARIANT_TOKENS.hideButton,
    },
});
//# sourceMappingURL=commonStateTokens.js.map